export default function Services() {
  const services = [
    {
      title: 'Dock Replacement',
      description: 'Complete dock replacement services with high-quality materials and expert craftsmanship. We ensure your new dock meets all safety standards and exceeds your expectations for durability and functionality.',
      icon: 'ri-ship-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20dock%20construction%20workers%20installing%20a%20new%20wooden%20dock%20with%20modern%20pilings%20and%20decking%20materials%20at%20a%20marine%2C%20clear%20blue%20water%2C%20construction%20equipment%20visible%2C%20bright%20sunny%20day%20with%20simple%20clean%20background%20highlighting%20the%20dock%20structure%20and%20professional%20craftsmanship&width=800&height=600&seq=dock-replacement-001&orientation=landscape'
    },
    {
      title: 'Dock Repair',
      description: 'Expert dock repair services to restore and maintain your existing dock structure. From minor fixes to major structural repairs, we handle all aspects of dock maintenance with precision and care.',
      icon: 'ri-tools-line',
      image: 'https://readdy.ai/api/search-image?query=Skilled%20contractor%20repairing%20wooden%20dock%20structure%20with%20tools%20and%20equipment%2C%20fixing%20damaged%20planks%20and%20supports%2C%20marine%20setting%20with%20calm%20water%2C%20professional%20repair%20work%20in%20progress%20with%20simple%20clean%20background%20emphasizing%20the%20repair%20details%20and%20quality%20workmanship&width=800&height=600&seq=dock-repair-001&orientation=landscape'
    },
    {
      title: 'Marine Plumbing',
      description: 'Specialized marine plumbing services for docks and marines. We install and repair water systems, sewage systems, and all plumbing infrastructure with marine-grade materials built to withstand harsh conditions.',
      icon: 'ri-water-flash-line',
      image: 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/2613885c374673eacdfe53ff66dfc3b7.jpeg'
    },
    {
      title: 'Marine Electrical',
      description: 'Professional marine electrical services including power distribution, lighting systems, and electrical infrastructure for docks and marines. All work meets marine electrical codes and safety standards.',
      icon: 'ri-flashlight-line',
      image: 'https://readdy.ai/api/search-image?query=Licensed%20electrician%20installing%20marine%20electrical%20systems%20and%20lighting%20on%20a%20dock%2C%20electrical%20panels%20and%20wiring%2C%20marine%20environment%20with%20boats%2C%20professional%20electrical%20work%20with%20simple%20clean%20background%20showcasing%20the%20electrical%20installation%20and%20safety%20compliance&width=800&height=600&seq=marine-electrical-001&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive contracting services for all your dock, plumbing, mechanical, and electrical needs. Licensed, insured, and committed to excellence.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="w-14 h-14 flex items-center justify-center bg-[#172554] text-white rounded-lg mb-4">
                  <i className={`${service.icon} text-2xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
